import {NgModule} from '@angular/core';
import {ActivityLogsService} from './activity-logs.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [ActivityLogsService]
})
export class ActivityLogsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/activity-logs/activity-logs.module.ts